import {
  coreV1DeleteDataSourceMutation,
  DbuiV1GetDataSourceSummaryResponse,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useDeleteDataSource = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({
      dataSource,
    }: {
      dataSource: NonNullable<
        DbuiV1GetDataSourceSummaryResponse['dataSources']
      >[number];
    }) =>
      coreV1DeleteDataSourceMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: {}, path: { name: dataSource.name, workspace } }),
  });
};
